import React, { useState, useRef, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../../Context';
import { ThemeOptions } from '../../../publicSession/types';
import s from './BasicUserAvatar.scss';
import { BiDataHook } from '../../../biLogger';
var MAX_PIXELATED_RESOLUTION = 50;
function isSmallGifImage(img) {
    var imgExtension = img.src.split('?').shift();
    if (!imgExtension) {
        return false;
    }
    imgExtension = imgExtension.split('.').pop();
    return (imgExtension === 'gif' &&
        img.naturalHeight <= MAX_PIXELATED_RESOLUTION &&
        img.naturalWidth <= MAX_PIXELATED_RESOLUTION);
}
export var BasicUserAvatar = function (_a) {
    var _b = _a.user, username = _b.username, usericon = _b.usericon, usericonDefault = _b.usericonDefault, type = _b.type;
    var t = useTranslation().t;
    var theme = useContext(ThemeContext);
    var _c = useState(false), shouldBePixelated = _c[0], setPixelated = _c[1];
    var imgRef = useRef(null);
    var isGroup = type && type.includes('group');
    var showDefaultUserAvatar = !isGroup && (usericonDefault || !usericon);
    var imgSrc = usericon;
    useEffect(function () {
        var img = imgRef.current;
        if (!img || !isSmallGifImage(img)) {
            return;
        }
        setPixelated(true);
    }, []);
    if (showDefaultUserAvatar) {
        imgSrc =
            theme === ThemeOptions.LIGHT
                ? 'https://st.deviantart.net/eclipse/icons/p07-light.svg?1'
                : 'https://st.deviantart.net/eclipse/icons/p07-dark.svg?1';
    }
    return (React.createElement("img", { "data-hook": BiDataHook.USER_AVATAR, alt: t('avatar.alt', {
            username: username || t('avatar.unknownUser'),
        }), className: classnames(s['user-avatar'], shouldBePixelated && s['pixelated']), ref: imgRef, src: imgSrc }));
};
BasicUserAvatar.displayName = 'BasicUserAvatar';
export default BasicUserAvatar;
//# sourceMappingURL=BasicUserAvatar.js.map